export default __webpack_public_path__ + "static/media/credit-card.d2ac3d54.png";